export const POLL_MDX_DIRECTIVE_NAME = 'crowdaa-press-poll';
